// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sx-editor-table-cell {\n  display: flex;\n  padding: 10px;\n}\n.sx-editor-table-cell i {\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
